module.exports = __webpack_public_path__ + "img/art_7_1.d425bd00.png";